const tabs = document.querySelectorAll('.product-tabs-main__wrapper ul li');
const productTabContents = document.querySelectorAll('.product-tabs-main__wrapper .tab_content > div');

function setActiveTab(targetId) {
  tabs.forEach(tab => {
    if (tab.getAttribute('data-tab') === targetId) {
      tab.classList.add('active');
    } else {
      tab.classList.remove('active');
    }
  });

  productTabContents.forEach(content => {
    if (content.getAttribute('id') === targetId) {
      content.classList.add('active');
    } else {
      content.classList.remove('active');
    }
  });
}

tabs.forEach(tab => {
  tab.addEventListener('click', function (event) {
    event.preventDefault();
    const targetId = tab.getAttribute('data-tab');
    setActiveTab(targetId);
  });
});

if (tabs.length > 0) {
  const firstTabId = tabs[0].getAttribute('data-tab');
  setActiveTab(firstTabId);
}

/**mobile**/
const accordionHeaders = document.querySelectorAll(".accordion-header");

accordionHeaders.forEach((header) => {
  header.addEventListener("click", function () {
    const panel = this.nextElementSibling;
    const isActive = this.classList.contains("active");

    // Close all accordion panels
    accordionHeaders.forEach((hdr) => hdr.classList.remove("active"));
    document.querySelectorAll(".accordion-panel").forEach((panel) => {
      panel.style.display = "none";
    });

    // Toggle current panel
    if (!isActive) {
      this.classList.add("active");
      panel.style.display = "block";

      // Scroll to the clicked header with a margin of 120px
      const headerOffset = 120;
      const elementPosition = this.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  });
});

/**owl slider**/
setTimeout(() => {
  $('.product-tabs-main__wrapper .owl-carousel').owlCarousel({
  loop: false,
  margin: 0,
  nav: true,
  dots:false,
  dragEndSpeed: 600,
  mouseDrag: true,
  touchDrag: true,
  responsive: {
      0: { items: 1,margin: 10, dots: false, },
      767: { items: 2 , margin: 20 ,dots: true  },
      1200: { items: 3 , margin: 20, dots: false }
  }
});
}, 3000)